import { NgClass, NgFor, NgIf } from "@angular/common";
import { Component, OnInit } from "@angular/core";
import { ExtendedModule } from "@angular/flex-layout/extended";
import { MatIconButton } from "@angular/material/button";
import { MatIcon } from "@angular/material/icon";
import { RouterLink, RouterLinkActive } from "@angular/router";
import { environment } from "src/environments/environment";
import { DeviceService } from "../service/device.service";
import { MetricsService } from "../service/metrics.service";
import { NavigationService } from "../service/navigation.service";
import { EmployeeService } from "../shared/services/employee.service";

@Component({
  selector: "app-sidenav",
  templateUrl: "./sidenav.component.html",
  styleUrls: ["./sidenav.component.scss"],
  imports: [
    MatIconButton,
    MatIcon,
    NgIf,
    RouterLink,
    ExtendedModule,
    NgFor,
    RouterLinkActive,
    NgClass,
  ],
})
export class SidenavComponent implements OnInit {
  hoverName;
  sideNavItems = [];
  showEnvironmentBanner = environment.showEnvironmentBanner;
  constructor(
    protected navigationService: NavigationService,
    protected deviceService: DeviceService,
    private employeeService: EmployeeService,
    private metricService: MetricsService
  ) {}

  ngOnInit(): void {
    this.sideNavItems = this.navigationService.getStoredSideNavItems();
    this.employeeService.getBio().subscribe((bio) => {
      this.metricService.getUserMetrics(bio).subscribe((metrics) => {
        this.sideNavItems = this.navigationService.generateSideNavItems(bio, metrics);
      });
    });
  }

  setHover(name) {
    this.hoverName = name;
  }

  closeHover() {
    this.hoverName = null;
  }

  onNavSelection() {
    this.navigationService.opened = false;
  }
}
